import { Box, Drawer, Typography } from '@mui/material';
import { FunctionComponent } from 'react';

import { EventForm } from '../EventForm/EventForm';
import { useCreateEventDrawer } from './useCreateEventDrawer';

interface CreateEventDrawerProps {
  isOpen: boolean;
  onClose: (createdEventId?: string) => void;
}

export const CreateEventDrawer: FunctionComponent<CreateEventDrawerProps> = ({
  isOpen,
  onClose,
}) => {
  const {
    endAtValue,
    errors,
    onEndAtChange,
    onStartAtChange,
    onSubmit,
    register,
    onPlaceChange,
    startAtValue,
    onTypeChange,
    type,
  } = useCreateEventDrawer(onClose);

  return (
    <Drawer anchor="right" open={isOpen} onClose={() => onClose()}>
      <Box sx={{ mt: 10, mx: 2 }}>
        <Typography variant="h4">Créer un événement</Typography>
        <EventForm
          register={register}
          onSubmit={onSubmit}
          errors={errors}
          endAtValue={endAtValue}
          startAtValue={startAtValue}
          onEndAtChange={onEndAtChange}
          onStartAtChange={onStartAtChange}
          onPlaceChange={onPlaceChange}
          submitButtonLabel="Créer"
          onTypeChange={onTypeChange}
          type={type}
        />
      </Box>
    </Drawer>
  );
};
